import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);



function whereNext(){

    const whereNext = $qsa('[data-name="where-next"]');
    const whereNextTeasers = $qsa('[data-name="where-next-teasers"]');

    if (!whereNextTeasers) return;

    const timeline = gsap.timeline();

    timeline.from(whereNextTeasers, {opacity: 0, y: '20px', stagger: 0.5})

        ScrollTrigger.create({
            trigger: whereNext,
            start: 'top bottom',
            animation: timeline
        })
}


export default whereNext;